import { Message as ApiMessage } from "entities/ApiModel/Message";
import { Message as UiMessage } from "entities/UIModel/Message";

import { parseDateString, removeWhiteSpaces } from "utils/shared";
import { mapToUiDocument } from "./documentHelper";

export const mapToUiMessages = (data: ApiMessage[]) => (): UiMessage[] => {
  if (!data || data.length === 0) {
    return [];
  }

  return data.map((d: ApiMessage) => ({
    uniqueIdentifier: (d.MessageID || 0).toString(),
    integrationKey: d.IntegrationKey,
    fileID: d.FileID,
    orderID: d.OrderID,
    messageID: d.MessageID,
    externalMessageID: d.ExternalMessageID,
    messageFromName: d.MessageFromName,
    messageSubject: d.MessageSubject,
    messageText: d.MessageText,
    attachmentData: d.AttachmentData,
    messageCreatedByUserID: d.MessageCreatedByUserID,
    messageCreatedDate: d.MessageCreatedDate ,
    needByDate: parseDateString(d.NeedByDate), // d.NeedByDate,
    messageSentDate: d.MessageSentDate ,
    messageSenderTypeCode: d.MessageSenderTypeCode,         
    messageRecipientTypeCode: d.MessageRecipientTypeCode,   
    isHidden: d.IsHidden,
    forStaffViewOnly: d.ForStaffViewOnly,
    originationSource: d.OriginationSource,
    originationSourceCode: d.OriginationSourceCode,
    rowClassName: d.OriginationSource &&
    ["resware", "stewarttitleproduction"].includes(removeWhiteSpaces(d.OriginationSource).toLowerCase())
      ? "resware"
      : "" ,  
    originationUser: d.MessageCreatedByUserName?.replaceAll("|", " "),
    documents: d.Documents ? d.Documents.map(mapToUiDocument) : [],
  }));
};
